export  const language_return = ()=>{
 let userData = JSON.parse(localStorage.getItem("amanrowuserData"))
 if(userData.language_cd == "en"){return }

 document.getElementById("item_name_arabic").innerText = "اسم المادة"
}